import React from 'react'
import './Notifications.css'
import NotificationPage from '../../Notification/NotificationPage'

const Notifications = ({role}) => {

  
  return (
    <div className='notifications-con'>
      <NotificationPage role={role}/>
    </div>
  )
}

export default Notifications
